<template>
  <div class="ride-workflows-list main">
    <div class="wrapper">
      <button class="delete is-large" @click="$emit('close')" />
      <img :src="vehicleIcon" @click="$emit('close')" />
      <h1 class="subtitle">
        <span>{{ name }} Workflows</span>
      </h1>

      <div class="field">
        <p class="control has-icons-left has-icons-right">
          <input
            class="input is-info has-text-info is-rounded"
            placeholder="Search"
            v-model="searchTerm"
            @focus="searchTerm = null"
            @blur="searchTerm = null"
            @keyup="search"
          />
          <span class="icon is-small is-left"><i class="fa fa-search" /></span>
          <span class="icon is-small is-right"><i class="fa fa-filter" /></span>
        </p>
      </div>

      <div class="list has-text-left" style="margin-bottom: 10px" :key="z">
        <span
          v-for="(w, i) in workflows"
          :key="i"
          class="list-item is-pointer"
          :class="{ 'bg-grey': inactiveState(w) }"
          @click="selected = w"
        >
          <span class="stop-name no-scrollbar"> {{ w.business.name }}</span>
          <span class="distance is-pulled-right">{{ w.distancePretty }}</span>
        </span>
        <span v-if="!workflows.length" class="list-item has-text-primary">
          <i>No Match</i><i class="fa fa-undo-alt" style="margin-left: 9px" />
        </span>
      </div>
    </div>

    <fade-transition>
      <RideWorkflowData
        v-if="selected"
        :workflow="selected"
        @close="selected = null"
      />
    </fade-transition>
  </div>
</template>

<script>
import vehicles from "@/vehicles";
import geo from "@/geo";

import RideWorkflowData from "@/components/RideWorkflowData.vue";

export default {
  components: {
    RideWorkflowData,
  },
  props: {
    name: String,
  },
  data() {
    return {
      selected: null,
      showWorkflowData: false,
      showLocationMap: false,
      searchTerm: null,
      z: 0,
    };
  },
  computed: {
    workflows() {
      return this.$store.state.transport.filter(
        (t) => t.name === this.name && this.match(t) // match check search text
      );
    },
    vehicleIcon() {
      return vehicles.img(this.name);
    },
  },
  mounted() {
    console.log("mounted RideWorkflowsList");
    this.sortWorkflows();
  },
  methods: {
    inactiveState(w) {
      return w.state === "inactive"; // or w.state !== "active"
    },
    sortWorkflows() {
      var userCoords = this.$store.getters.getUserLatLon;
      var transports = this.workflows;
      transports.forEach((t) => {
        t.distance = geo.distanceToUserInMeters(t.business, userCoords);
        t.distancePretty = geo.prettyDistance(t.distance);
      });
      transports.sort((a, b) => {
        return a.distance - b.distance;
      });
      this.z += 1;
    },
    settingStyle(val) {
      if (this.setting !== val) return null;
      return `background-color: #f1ffed`;
    },
    match(t) {
      return JSON.stringify(t).toLowerCase().includes(this.searchTerm);
    },
    search(e) {
      this.searchTerm = e.target.value.toLowerCase();
    },
  },
};
</script>

<style scoped>
.main {
  position: absolute;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1101;
  /* random z-index higher than modal */
  backdrop-filter: blur(3px);
  overflow: hidden;
}
.wrapper {
  padding: 12px;
  text-align: left;
  height: 100vh;
  background-color: rgba(17, 34, 51, 0.85);
  /* color: white; */
}
.subtitle {
  color: white;
  opacity: 0.7;
  font-weight: 450;
  margin-left: 45px;
  margin-top: 6px;
}
.delete {
  position: absolute;
  right: 12px;
  top: 12px;
  z-index: 2;
}
.bg-grey {
  background-color: lightgray;
}
.fa-search {
  color: lightskyblue;
}
.key {
  font-weight: 550;
  color: rgba(84, 84, 84, 0.7);
  padding-right: 0;
}
input::-webkit-input-placeholder {
  color: #2693da !important;
  font-weight: 500;
  opacity: 0.8;
}
.submit {
  position: absolute;
  right: 12px;
  margin-top: -4px;
  padding: 10px 15px;
  background-color: #00d1b2;
  color: white;
  /* font-size: 1.em; */
  font-weight: 500;
  /* #35AC5E #00D1B2 */
  border-radius: 10px;
}
.fa-times-circle {
  margin-top: 3px;
  opacity: 0.7;
  color: grey;
}
img {
  position: absolute;
  left: 12px;
  height: 35px;
  background-color: white;
  padding: 1px;
  border-radius: 10px;
}
.fixed-stop {
  background-color: rgb(237, 237, 237);
}
.distance {
  font-size: 0.8em;
  font-weight: 550;
  opacity: 0.4;
  margin-top: 3px;
}
.stop-name {
  display: inline-block;
  max-width: calc(100vw - 100px);
  white-space: nowrap;
  overflow: auto;
  vertical-align: bottom;
}
.pulse {
  font-size: 0.8em;
  border-radius: 50%;
  animation: shadow-pulse 2s 999;
}
@keyframes shadow-pulse {
  0% {
    box-shadow: 0 0 0 0px cyan;
  }
  100% {
    box-shadow: 0 0 0 4px rgba(0, 255, 255, 0.4);
  }
}
.pulse-btn {
  animation: shadow-pulse-green 2s infinite;
}
.pulse-stop {
  animation: shadow-pulse-green 2s infinite;
  border-radius: 20px;
}
@keyframes shadow-pulse-gold {
  0% {
    box-shadow: 0 0 0 0px rgba(247, 211, 8, 0.95);
  }
  100% {
    box-shadow: 0 0 0 6px rgba(247, 211, 8, 0.2);
  }
}
@keyframes shadow-pulse-green {
  0% {
    box-shadow: 0 0 0 0px lightgreen;
  }
  100% {
    box-shadow: 0 0 0 6px rgba(144, 238, 144, 0.5);
  }
}
</style>

<style lang="scss">
// puts the google places autocomplete dropdown results above this modal
// #ride-where-to-autocomplete {
.pac-container {
  z-index: 1101 !important;
}
// }
</style>